
export class NoRenderingError extends Error {
  constructor(displayName: string) {
    super(`${displayName}: This component is not meant to be rendered. It's an abstract component that should only be used inside a TabCaontainer as its child.`);
  }
}
